import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';
import { ServiceCard } from '../components/ServiceCard';

class ShopPrinters extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { services } = this.props;

    return (
      <div>
        <PageBanner title='Shop Printers' background='page-banner.jpg' />
        <div className='p-5'>
          <h3 className='mb-2'>All Printers</h3>
          <p className='mb-4'>
            Browse our full range of printers. Whether you need an inkjet for
            home use or a laser printer for the office, we have you covered.
          </p>
          <div className='products-grid'>
            {services.map((service, index) => (
              <ServiceCard key={index} service={service} index={index} />
            ))}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  services: state.services.services,
});

export default connect(mapStateToProps)(ShopPrinters);
